import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";
import { encryptedManualOrderTags } from "@/utils/OrderTagUtils";

/**
 * 手工店铺标签组件
 * 包含所有手工店铺相关的标签逻辑
 */
export default function useManualShopTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    encryptedManualOrderTags.forEach((encryptedManualOrderTag) => {
        if (orderTagSet.has(encryptedManualOrderTag)) {
            icons.push(
                <OrderTagWrap
                    className="order-icon icon-important"
                    key={encryptedManualOrderTag}
                    orderTag={encryptedManualOrderTag}
                />,
            );
        }
    });

    return icons;
}
